import { hasCrmPermissions } from "app/components/SideBar/utils";
import { SI_ROOT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import {
    SF_MANAGEMENT_ENRICHMENT_LOGS_ROUTE,
    SF_MANAGEMENT_JOB_ENRICHMENT_EDIT_ROUTE,
    SF_MANAGEMENT_MANAGE_ROUTE,
    SF_MANAGEMENT_ROOT_ENRICHMENT_ROUTE,
    SF_MANAGEMENT_ROOT_ROUTE_EXPORT,
    SF_MANAGEMENT_ROOT_URL,
} from "app/pages/sales-intelligence/constants/sl_routes";
import SfEnrichmentJobEditContainer from "app/pages/sales-intelligence/pages/crm-enrichment/containers/CrmEnrichmentJobEditContainer/SfEnrichmentJobEditContainer";
import SfEnrichmentJobWizardContainer from "app/pages/sales-intelligence/pages/crm-enrichment/containers/CrmEnrichmentJobWizardContainer/SfEnrichmentJobWizardContainer";
import EnrichmentLogsPageContainer from "app/pages/sales-intelligence/pages/crm-enrichment/containers/EnrichmentLogsPageContainer/EnrichmentLogsPageContainer";
import ManageExport from "app/pages/sales-intelligence/pages/manage-export/ManageExport";
import ManageIntegration from "app/pages/sales-intelligence/pages/manage-integration/ManageIntegration";
import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const salesforceConfig: RouterStateConfig = {
    [SF_MANAGEMENT_MANAGE_ROUTE]: {
        parent: "salesIntelligence",
        url: SF_MANAGEMENT_ROOT_URL,
        // @ts-ignore FIXME: strict migration - Type 'unknown' is not assignable to type 'ComponentType<any>' — redux compose() return type collapses to unknown beyond ~4 HOCs
        component: ManageIntegration,
        configId: "SalesWorkspace",
        stateId: SF_MANAGEMENT_MANAGE_ROUTE,
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "manage salesforce",
        },
        pageTitle: "si.pages.management.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: hasCrmPermissions(),
    },
    [SF_MANAGEMENT_ROOT_ROUTE_EXPORT]: {
        parent: "salesIntelligence",
        url: `${SF_MANAGEMENT_ROOT_URL}/export`,
        // @ts-ignore FIXME: strict migration - Type 'unknown' is not assignable to type 'ComponentType<any>' — redux compose() return type collapses to unknown beyond ~4 HOCs
        component: ManageExport,
        configId: "SalesWorkspace",
        trackingId: {
            section: "salesforce management",
            subSection: "",
            subSubSection: "",
        },
        pageTitle: "si.pages.management.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: hasCrmPermissions(),
    },
    [SF_MANAGEMENT_ROOT_ENRICHMENT_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: `${SF_MANAGEMENT_ROOT_URL}/enrichment`,
        // @ts-ignore FIXME: strict migration - Type 'unknown' is not assignable to type 'ComponentType<any>' — redux compose() return type collapses to unknown beyond ~4 HOCs
        component: SfEnrichmentJobWizardContainer,
        configId: "SalesWorkspace",
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "edit salesforce enrichment",
        },
        pageTitle: "si.pages.management.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: hasCrmPermissions(),
    },
    [SF_MANAGEMENT_JOB_ENRICHMENT_EDIT_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: `${SF_MANAGEMENT_ROOT_URL}/enrichment/:id`,
        // @ts-ignore FIXME: strict migration - Type 'unknown' is not assignable to type 'ComponentType<any>' — redux compose() return type collapses to unknown beyond ~4 HOCs
        component: SfEnrichmentJobEditContainer,
        configId: "SalesWorkspace",
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "edit salesforce enrichment",
        },
        pageTitle: "si.pages.management.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: hasCrmPermissions(),
    },
    [SF_MANAGEMENT_ENRICHMENT_LOGS_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: `${SF_MANAGEMENT_ROOT_URL}/enrichment/logs/:jobId`,
        // @ts-ignore FIXME: strict migration - Type 'unknown' is not assignable to type 'ComponentType<any>' — redux compose() return type collapses to unknown beyond ~4 HOCs
        component: EnrichmentLogsPageContainer,
        configId: "SalesWorkspace",
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "salesforce enrichment logs",
        },
        pageTitle: "si.pages.management.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: hasCrmPermissions(),
    },
};
